var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStarBigOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FCD933",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 21.13l-7.257 3.856c-.526.28-1.141-.172-1.04-.764l1.385-8.17-5.87-5.786c-.426-.42-.191-1.15.397-1.237l8.113-1.192L12.357.404c.263-.539 1.023-.539 1.286 0l3.629 7.433 8.113 1.192c.588.087.823.818.398 1.237l-5.871 5.786 1.386 8.17c.1.592-.515 1.044-1.041.764L13 21.13z",
    transform: "translate(-107 -180) translate(107 180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarBigOn);
export default __webpack_public_path__ + "static/media/ic_starBig_on.7003030f48397d9227b6ddfd0c30252d.svg";
export { ForwardRef as ReactComponent };